import axios from "axios";
import { api } from "./api_route";

export const caseChecklistDocumentsVerificationAPI = async (caseID) => {
  try {
    const response = await axios.post(
      `${api}/caseChecklistTab/caseChecklistDocumentsVerification`,
      { caseID },
    );

    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const bulkChecklistPDFAPI = async (caseIDs, caseTypeID) => {
  try {
    const response = await axios.post(
      `${api}/caseChecklistTab/bulkChecklistPDF`,
      { caseIDs, caseTypeID },
      {
        responseType: "blob",
      },
    );
    return response.data;
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};
